module.exports = __webpack_public_path__ + "img/last-track-button.f62bd5a2.png";